//设置
import setting from '@/views/setting'
import peopleSetting from '@/views/setting/peopleSetting'
import channelSetting from '@/views/setting/channelSetting'
import BigImg from '@/views/setting/BigImg'
import accout from '@/views/setting/accout'
import posAdministration from '@/views/card/posAdministration'
import addrAdd from '@/views/card/addrAdd'
import notice from '@/views/setting/notice'
import newsDetail from '@/views/setting/newsDetail'
import declassify from '@/views/setting/declassify'
import goods from '@/views/setting/goods'

export default [
		{
			path: '/setting',
			name: 'setting',
			meta:[{name:'机构设置'}],
			component: setting
		},
		{
			path: '/setting/peopleSetting',
			name: 'peopleSetting',
			meta:[{name:'员工设置'}],
			component: peopleSetting
		},
		{
			path: '/setting/channelSetting',
			name: 'channelSetting',
			meta:[{name:'渠道管理'}],
			component: channelSetting
		},
    {
			path: '/setting/BigImg',
			name: 'BigImg',
			meta:[{name:'渠道管理'}],
			component: BigImg
		},
    {
			path: '/setting/goods',
			name: 'goods',
			meta:[{name:'商品管理'}],
			component: goods
		},
		{
			path: '/setting/accout',
			name: 'accout',
			meta:[{name:'江泰账户信息'}],
			component: accout
		},
		{
		  path: '/setting/addrAdd',
		  name: 'addrAdd',
			meta:[{name:'地址管理'}],
		  component: addrAdd
    },
    {
		  path: '/setting/posAdministration',
		  name: 'posAdministration',
			meta:[{name:'Pos机管理'}],
		  component: posAdministration
    },
    {
		  path: '/setting/notice',
		  name: 'notice',
			meta:[{name:'通知公告'}],
		  component: notice
    },
    {
		  path: '/setting/declassify',
		  name: 'declassify',
			meta:[{name:'修改密码'}],
		  component: declassify
    },
    {
		  path: '/setting/newsDetail',
		  name: 'newsDetail',
			meta:[{name:'通知详情'}],
		  component: newsDetail
		}
]


// WEBPACK FOOTER //
// ./src/router/setting.js